import * as React from 'react';
import { Input } from '@makemydeal/ui-bricks/dist/cox';
import type { InputFieldProps } from '@makemydeal/dr-ui-bricks-types';
import { StyledInputField } from './inputField.style';

const InputField: React.FC<InputFieldProps> = ({
    label,
    name,
    value,
    onChange,
    placeholder = '',
    className = '',
    disabled = false,
    errorMessage = '',
    inputMode = 'text',
    maxLength,
    type = 'text',
    validationFunction,
    hasError = false
}) => {
    return (
        <StyledInputField className={`input-field-wrapper ${className}`}>
            <Input
                label={label}
                name={name}
                value={value}
                onChangeFunction={onChange}
                placeholder={placeholder}
                className="input-field"
                disabled={disabled}
                errorMessage={errorMessage}
                inputMode={inputMode}
                maxLength={maxLength}
                type={type}
                validationFunction={validationFunction}
                hasError={hasError}
            />
        </StyledInputField>
    );
};

export default InputField;
